import { ColorVariant } from '@ui-components/neo.tax';

/**
 * Single color used for all projects throughout the application.
 * Change this value to test different color schemes (e.g., DARK_AQUA).
 */
export const HIGHLIGHT_VARIANT = ColorVariant.BLUE;

// https://www.figma.com/file/MEHs26BXTZPcmXdsINyNkh/DSG-858-%7C-Gaap-Cap-4.x---Edit-allocations?type=design&node-id=260-11460&mode=design&t=ggcQ4NbCFcE7ggSB-4
const PROJECT_COLOR_VARIANTS: ColorVariant[] = [
  ColorVariant.PRIMARY,
  ColorVariant.BLUE,
  ColorVariant.LIGHT_GREEN,
  ColorVariant.LIGHT_LIME,
  ColorVariant.DARK_AQUA,
  ColorVariant.DARK_AVOCADO,
  ColorVariant.ORANGE,
  ColorVariant.LIGHT_RSBRY,
  ColorVariant.LIGHT_LEMON,
  ColorVariant.LIGHT_AVOCADO,
  ColorVariant.DARK_BLUE,
  ColorVariant.LIGHT_BLUE,
  ColorVariant.LIGHT_PRIMARY,
  ColorVariant.GREEN,
  ColorVariant.RSBRY,
  ColorVariant.LIME,
  ColorVariant.AQUA,
  ColorVariant.LEMON,
  ColorVariant.LIGHT_ORANGE,
  ColorVariant.GRAY,
];

export const getProjectColorVariant = (index: number): ColorVariant =>
  PROJECT_COLOR_VARIANTS[index % PROJECT_COLOR_VARIANTS.length];
